import {
  BillingPriceInterval,
  type BillingProduct,
} from '@tribeplatform/gql-client/types'

export const getDefaultPriceByInterval = (
  product: BillingProduct,
  interval: BillingPriceInterval,
) =>
  product.prices.find(price => price.default && price.interval === interval) ??
  product.prices.find(price => price.interval === interval)

export const getPlanPricing = (
  product: BillingProduct,
  interval: BillingPriceInterval,
) => {
  const price = getDefaultPriceByInterval(product, interval)
  const monthlyPrice = getDefaultPriceByInterval(
    product,
    BillingPriceInterval.Month,
  )

  let monthlyAmount = 0

  if (price) {
    monthlyAmount =
      price.interval === BillingPriceInterval.Month
        ? price.amount / 100
        : price.amount / 100 / 12
  }

  const yearlyTotal = price ? monthlyAmount * 12 : null

  const monthlyTotal = monthlyPrice ? (monthlyPrice.amount / 100) * 12 : null
  const savingsPercent =
    monthlyTotal && price && price.interval === BillingPriceInterval.Year
      ? Math.round(((monthlyTotal - price.amount / 100) / monthlyTotal) * 100)
      : null

  return {
    price,
    monthlyPrice,
    monthlyAmount,
    yearlyTotal,
    savingsPercent,
  }
}
